<template>
    <div>
        <h2 class="stack-m padding-top-s margin-top-xs">Segments</h2>
        <starred-segments
            v-if="segmentCollection.hasStarredSegments"
            :segments="segmentCollection.activePage.starredSegments"
            class="margin-bottom-m"/>
        <div v-for="category in segmentCollection.activePage.categories" :key="category.name" class="margin-bottom-m">
            <segment-column-category
                :category="category"
                :segment-collection="segmentCollection"
                :active-segment="activeSegment"
            />
        </div>
        <div>
            <router-link
                class="btn btn-link margin-top-s"
                v-if="$auth.gridSegments.add.isAllowed"
                :to="{name: 'add-segment', params: {page: segmentCollection.activePage.name}}"
                type="link">Add new segment</router-link>
        </div>
        <div>
            <router-link
                class="btn btn-link margin-top-s"
                :to="{
                    name: 'segment-management',
                    params: {
                        page: segmentCollection.activePage.name,
                        category: segmentCollection.activePage.activeCategory.name
                        }
                }"
                type="link">Manage Segments</router-link>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import SegmentLink from '@/modules/segments/components/segment-link';
    import SegmentSearch from '@/modules/segments/components/segment-search';
    import SegmentColumnCategory from '@/modules/segments/components/column/segment-column-category';
    import StarredSegments from '@/modules/segments/components/column/starred-segments';
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'segments-column',
        components: {
            vIcon,
            SegmentLink,
            SegmentSearch,
            StarredSegments,
            SegmentColumnCategory,
        },
        computed: {
            ...mapGetters({
                segmentCollection: 'segments/segmentCollection',
                activeSegment: 'segments/activeSegment',
            }),
        },
        watch: {
            /**
             * Watch the segmentId in the route. If it changes save it as the active segment ID
             * in the store.
             */
            '$route.params.segmentId': {
                immediate: true,
                handler: function updateIdFromRoute(newVal, oldVal) {
                    if (oldVal !== newVal && newVal !== undefined) {
                        try {
                            this.setActiveSegmentId(newVal);
                            this.updateActiveFilters(this.activeSegment.data.filters);
                        } catch (err) {
                            // segment ID was not found
                        }
                    }
                },
            },
        },
        methods: {
            ...mapActions({
                setActiveSegmentId: 'segments/setActiveSegmentId',
                toggleHiddenSegments: 'segments/toggleHiddenSegments',
                activateSegmentCategory: 'segments/activateSegmentCategory',
                updateActiveFilters: 'segments/updateActiveFilters',
                fetchSegmentsCount: 'segments/fetchSegmentsCount',
            }),
            openCategory(categoryName) {
                this.activateSegmentCategory(categoryName);
                this.updateActiveFilters(this.activeSegment.data.filters);
            },
        },
        created() {
            this.updateActiveFilters(this.activeSegment.data.filters);
            this.fetchSegmentsCount([
                ...this.segmentCollection.activeCategory.$visibleSegments,
                ...this.segmentCollection.activeCategory.$hiddenSegments,
            ]);
        },
    };
</script>
